angular
	.module 'App'
	.config ($httpProvider) ->
		$httpProvider.interceptors.push 'httpInterceptor'
	.factory 'httpInterceptor',
		($q, $rootScope, $window, localStorageService, ToastService, ENV, API_VERSION, API_ENDPOINT) ->
			requestCounter = 0
			$rootScope.appLoading = false

			request: (request) ->
				getCorrelationId = ->
					correlationId = localStorageService.get 'correlation_id'

					if correlationId == null
						randomInt = self.crypto.getRandomValues(new Uint32Array(1))[0]
						correlationId = "backoffice-#{ENV.tenant}-#{ENV.environment}-#{randomInt}"

						localStorageService.set 'correlation_id', correlationId

					return correlationId

				requestCounter++
				$rootScope.appLoading = true

				if request.url.startsWith(API_ENDPOINT)
					request.headers['Wm-Api-Version'] = API_VERSION
					request.headers['X-Correlation-Id'] = getCorrelationId()

				return request || $q.when request

			requestError: (request) ->
				console.warn('Request rejected', request)

				return $q.reject request

			response: (response) ->
				requestCounter--
				$rootScope.appLoading = false if requestCounter == 0

				if response.config.method != "GET"
					ToastService.showDefaultSuccess response

				return response || $q.when response

			responseError: (response) ->
				console.warn('Response rejected', response)
				requestCounter--
				$rootScope.appLoading = false if requestCounter == 0
				ToastService.showDefaultError response

				return $q.reject response
